import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Horizon Blue Cross Blue Shield of New Jersey",
  shortName: "Horizon BCBS NJ",
  slug: "horizon-blue-insurance",
  seoTitle: "Horizon BCBS New Jersey TMS Coverage | Neuro Wellness TMS",
  seoDescription:
    "Have Horizon Blue Cross Blue Shield of New Jersey? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your Horizon BCBS NJ plan in Coral Springs, FL.",
  seoKeywords:
    "Horizon BCBS NJ TMS coverage, Horizon Blue Cross New Jersey TMS therapy, Horizon BCBS NJ depression treatment Florida, Horizon Blue mental health benefits Coral Springs FL, Horizon BCBS NJ SAINT TMS",
  planType: "Blue Cross Blue Shield affiliate health insurance plan",
  planRegion: "New Jersey",
  memberTerm: "members",
  behavioralHealthTerm:
    "behavioral health benefits, including mental health services",
  planSpecificIntro:
    "Horizon Blue Cross Blue Shield of New Jersey is an independent licensee of the Blue Cross Blue Shield Association, providing health coverage to members across New Jersey. Horizon BCBS NJ plans generally include behavioral health benefits that may cover TMS therapy when medical necessity criteria are met. Horizon BCBS NJ network plans have options within specific policies for accelerated protocols. Coverage is reviewed and determined case by case, depending on your individual plan, network status, and documented prior treatment history.",
  officialResourceUrl: "https://www.horizonblue.com/",
  officialResourceLabel:
    "Horizon Blue Cross Blue Shield of New Jersey official website",
};

export const HorizonBlueInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default HorizonBlueInsurance;
